<auth-layout title="{{ title }} Login" subTitile="Access eXobe using your email and password." [isHiddenImage]="true" [hideHeader]="true">
  <div class="login-page">
    <div class="login-card">
      <div class="login-header">
        <div class="logo-wrapper">
          <img src="assets/latest/logo1.png" alt="Exobe Logo" class="login-logo" />
        </div>
        <h2 class="h1">{{ title }} Login</h2>
        <p class="subtitle">Access eXobe using your email and password.</p>
      </div>

      <form [formGroup]="loginForm" class="login-form">
        <div class="form-group">
          <label for="username">Email Address<span class="redis">*</span></label>
          <div class="input-control">
            <input type="text" class="form-control" placeholder="Enter your email" formControlName="email"
              maxlength="60" (keypress)="preventSpace($event)" id="username" />
          </div>
          <div class="for-validation mb-2">
            <div class="for-validation text-danger" *ngIf="
                loginForm.get('email')?.hasError('required') && 
                (loginForm.get('email')?.touched || isSubmitted)
              ">
              *Please enter email id.
            </div>
            <div class="for-validation text-danger" *ngIf="
                loginForm.get('email')?.hasError('pattern') && 
                (loginForm.get('email')?.touched || isSubmitted)
              ">
              *Please enter a valid email.
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="label-row">
            <label for="password">Password<span class="redis">*</span></label>
            <a [routerLink]="['/forgot-customer']" class="forgot-pass">Forgot Password?</a>
          </div>
          <div class="input-control position-relative">
            <input placeholder="Enter your password" [type]="showPassword ? 'password' : 'text'" class="form-control"
              id="password" maxlength="16" (keypress)="preventSpace($event)" onselectstart="return false;"
              onpaste="return false;" oncopy="return false;" oncut="return false;" ondrag="return false;"
              ondrop="return false;" autocomplete="off" formControlName="password" />

            <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"
              (click)="changePasswordIcon()"></i>
          </div>

          <div class="for-validation mb-3">
            <div class="for-validation text-danger" *ngIf="
                loginForm.get('password')?.hasError('required') &&
                (loginForm.get('password')?.touched || isSubmitted)
              ">
              *Password is required.
            </div>
          </div>
        </div>

        <div class="form-meta">
          <label class="remb">
            <input type="checkbox" checked="checked" formControlName="checkbox" />
            Remember me
          </label>
        </div>

        <div class="cta-group">
          <button class="for-login btn text-white btn-block" type="submit" [disabled]="loading"
            (click)="load();login()">
            {{ loading ? 'Loading...' : 'LOGIN NOW' }}
          </button>
          <div id="buttonDiv" class="for-login btn text-white btn-block mt-4 googlebutton"></div>
        </div>
      </form>

      <div class="right-wrap">
        <span>Don't have an account?</span>
        <button class="link" type="button" (click)="signUpUser()">Register</button>
      </div>
    </div>
  </div>
</auth-layout>